<template>
  <pt-order-new class="pt-order-new__page"></pt-order-new>
</template>

<script>
import PtOrderNew from 'cps/lab-order/pt-order-new/withData'
export default {
  name: 'pt-order-new__view',
  components: {
    'pt-order-new': PtOrderNew
  }
}
</script>
